import useQuery from 'hooks/useQuery';
import React from 'react';
import StudioSearchPage from 'views/StudioSearchPage/StudioSearchPage';
import StudioSearchRecent from 'views/StudioSearchPage/StudioSearchRecent';

const StudioSearchPageRoute = () => {
  const params = useQuery();

  return params.has('recent') ? <StudioSearchRecent /> : <StudioSearchPage />;
};

export default StudioSearchPageRoute;
